import React, { useEffect } from "react";
import Navbar from "./clientHom/Navbar";
import Footer from "./uniComponents/AndUsFooter";
import UnityLanding from "./unityMarketing/UnityLanding";
import "./UnityLearningPage.css";

const LEGACY_ANCHORS = {
  "unity-problem": "create",
  "unity-learning-create-section": "create",
  "unity-adaptive-learning": "adapt",
  "unity-learning-facilitate-section": "deliver",
  "unity-learning-role-based-reporting-title": "report",
  "unity-learning-use-cases-section": "use-cases",
  "unity-learning-final-conversion-cta": "start",
  "unity-page-content": "create",
};

export default function UnityLearningPage() {
  useEffect(() => {
    const previousTitle = document.title;
    const title = "Unity Learning | Create, deliver and adapt your training";
    const description = "Turn your knowledge into engaging training. Build with AI, export to your LMS or deliver adaptive learning in Unity. Explore plans and request a trial.";
    const canonical = "https://andus.co.za/unity-learning";
    document.title = title;
    const restore = [];
    const metadata = [
      ["meta", "name", "description", "content", description],
      ["meta", "property", "og:title", "content", title],
      ["meta", "property", "og:description", "content", description],
      ["meta", "property", "og:url", "content", canonical],
      ["meta", "property", "og:image", "content", "https://andus.co.za/assets/unity-learning/unity-learning-og.png"],
      ["meta", "property", "og:type", "content", "website"],
      ["meta", "name", "twitter:card", "content", "summary_large_image"],
      ["link", "rel", "canonical", "href", canonical],
    ];
    metadata.forEach(([tag, attribute, key, valueAttribute, value]) => {
      const existing = document.head.querySelector(`${tag}[${attribute}="${key}"]`);
      const element = existing || document.createElement(tag);
      const previous = element.getAttribute(valueAttribute);
      element.setAttribute(attribute, key);
      element.setAttribute(valueAttribute, value);
      if (!existing) document.head.appendChild(element);
      restore.push(() => {
        if (!existing) element.remove();
        else if (previous === null) element.removeAttribute(valueAttribute);
        else element.setAttribute(valueAttribute, previous);
      });
    });

    let frame;
    const scrollToAnchor = () => {
      const hash = window.location.hash.slice(1);
      const target = LEGACY_ANCHORS[hash] || hash;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (target) document.getElementById(target)?.scrollIntoView({ behavior: "instant" });
        else window.scrollTo(0, 0);
      });
    };
    scrollToAnchor();
    window.addEventListener("hashchange", scrollToAnchor);
    return () => {
      document.title = previousTitle;
      restore.forEach((reset) => reset());
      cancelAnimationFrame(frame);
      window.removeEventListener("hashchange", scrollToAnchor);
    };
  }, []);

  return (
    <div id="unity-learning-page-top" className="unity-learning-page">
      <Navbar />
      <main className="unity-learning-page__main">
        <UnityLanding globalNavHeight={0} />
      </main>
      <Footer />
    </div>
  );
}
